import { Vue, Prop, Component, Watch, Inject } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import type { IResourceModel } from '@/shared/model/briefing-widget.model';
import BriefingService from '@/service/briefing.service';

const appStore = namespace('appStore');
const briefingStore = namespace('briefingStore');

@Component({})
export default class ShareTopic extends Vue {
  @Inject('briefingService')
  private briefingService: () => BriefingService;

  @appStore.Mutation
  public setIsShowShareTopic!: (payload: boolean) => void;

  @briefingStore.Getter
  public getSelectedResource!: IResourceModel;

  @briefingStore.Mutation
  public setSelectedResource!: (payload: any) => void;

  @appStore.Getter
  public isShowDetailTopic!: boolean;

  @appStore.Mutation
  public setIsShowBackdrop!: (payload: boolean) => void;

  shareTopicURL = '';
  isCopied = false;
  conditionShare: boolean;

  @Watch('$route')
  onRouteChange() {
    this.closeShareTopic();
  }

  created() {
    this.conditionShare = true;
    this.$root.$on('shareTopic', this.shareTopic);
    if (this.$route.name !== 'TopicDetail') {
      this.shareTopicURL = window.location.origin + '/topic-detail/' + this.getSelectedResource.docId;
    } else {
      this.shareTopicURL = window.location.origin + '/topic-detail/' + this.$route.params.docId;
    }
  }

  mounted() {
    // const metaTitle = document.createElement('meta');
    // metaTitle.content = this.getSelectedResource?.title || '';
    // metaTitle.name = this.getSelectedResource?.title || '';
    // metaTitle.setAttribute('property', 'og:title');
    // document.getElementsByTagName('head')[0].appendChild(metaTitle);
    //
    // const metaImage = document.createElement('meta');
    // metaImage.content = this.getSelectedResource?.thumbnail || '';
    // metaImage.name = this.getSelectedResource?.thumbnail || '';
    // metaImage.setAttribute('property', 'og:image');
    // document.getElementsByTagName('head')[0].appendChild(metaImage);
  }

  destroyed() {
    this.$root.$off('shareTopic', this.shareTopic);
  }

  copyLink() {
    navigator.clipboard.writeText(this.shareTopicURL);
    this.isCopied = true;
    setTimeout(() => {
      this.isCopied = false;
    }, 5000);
  }

  shareTopic(docId) {
    this.shareTopicURL = window.location.origin + '/topic-detail/' + docId;
  }

  public shareOnTwitter() {
    // @ts-ignore
    // const share = await FB.ui(
    //   {
    //     display: 'popup',
    //     method: 'share',
    //     href: this.post.sourceId,
    //     quote: this.textShare,
    //   },
    //   response => {
    //     if (response && !response.error_message) {
    //       this.$bvModal.hide('shareModal');
    //       this.interactionUserService().handleShare(this.$store.getters.getId, PLATFORM.facebook, this.connectomeId);
    //     }
    //   }
    // );

    const linkShare = encodeURIComponent(this.shareTopicURL);

    // const facebook = 'https://www.facebook.com/sharer/sharer.php?s=100&p[url]=' + linkShare;
    // window.open(facebook, '_blank');

    const tweet = 'https://twitter.com/intent/tweet?url=' + linkShare;
    window.open(tweet, '_blank');
  }

  shareOnFacebook() {
    const facebookLink = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(this.shareTopicURL);
    window.open(facebookLink, '_blank');
  }

  public shareOnLinkedIn() {
    const linkShare = encodeURIComponent(this.shareTopicURL);

    const linkedIn = 'https://www.linkedin.com/sharing/share-offsite/?url=' + linkShare;
    window.open(linkedIn, '_blank');
  }

  closeShareTopic() {
    this.setIsShowShareTopic(false);
    this.setIsShowBackdrop(false);
    if (!this.isShowDetailTopic && this.$route.name !== 'TopicDetail') {
      this.setSelectedResource({});
    }
  }

  updateUserInformationActivity() {
    if (this.conditionShare) {
      this.briefingService().updateUserActivityInformation(
        'request ' + Math.ceil(Math.random() * 100),
        this.$store.getters.userIdentity?.id,
        null,
        this.getSelectedResource.docId,
        false,
        false,
        true,
        false
      );
      this.conditionShare = false;
    }
  }

  methodInsert(methodName) {
    this.updateUserInformationActivity();
    methodName();
  }

  doNothing() {}
}
